exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".span-accettazione {\n  float: left;\n  padding: 10px;\n  font-weight: bold;\n}\n\n.button-nov {\n  background-color: #ffffff !important;\n  border: 0px solid #ffffff !important;\n}\n\n.row {\n  margin-bottom: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-termini-utilizzo/dialog-termini-utilizzo.component.css
// module id = ../../../../../src/app/components/utilita/dialogs/dialog-termini-utilizzo/dialog-termini-utilizzo.component.css
// module chunks = main